import { useDispatch } from 'react-redux'
import { useQuery } from '@tanstack/react-query'
import { GETConceptListResponse, getConceptConfigurationList } from '@cbgms/api/support/conceptConfiguration/apis'
import { AsyncAction } from '@cbgms/base/redux/async-action'

export const useGetList = (concept: string) => {
  const dispatch = useDispatch()

  return useQuery({
    queryKey: [concept, 'concept-config-get-list'],
    queryFn: async () => {
      const { Data } = await dispatch(AsyncAction<GETConceptListResponse>(getConceptConfigurationList()))
      return Data
    },
    refetchOnWindowFocus: false
  })
}
